module.exports = __webpack_public_path__ + "img/Bahrain-Bay-development.jpeg.de993e0e.jpg";